










































































































































import HourSelector from '../../core/components/HourSelector.vue';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import Input from '../../core/components/Input.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate,
    parseFloatNumber,
    matchedIndexIdInArray,
    getUniqueId
} from '../../core/utils';
import { formattedDate } from '../../core/utils/table-formatters';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';

@Component({
    components: {
        Input,
        Loading,
        Combobox,
        Button,
        DatePickerSingle,
        HourSelector,
        SimpleTable
    }
})
export default class ModalManualFactor extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() vehicleID: number;
    @Prop({ default: null }) patchData: object | null;
    @Prop({ default: false }) saveOnMemory: boolean;
    @Prop({
        default() {
            return [];
        }
    })
    itemsManualFactorsTable: object | null;
    sortByManualFactors: string[] = ['start_date'];
    sortDescManualFactors: boolean[] = [true];
    headersManualFactorsTable: Array<object> = [
        {
            text: 'Fecha Inicio',
            value: 'start_date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Fecha Fin',
            value: 'end_date',
            formatter: this.dateFormatter,
            sortable: true,
            width: '180px'
        },
        {
            text: 'Factor de calibración Rinde (%)',
            value: 'performance_cal_factor_percent',
            formatter: this.parseNumber,
            align: 'left',
            sortable: true
        },
        {
            text: 'Factor de Humedad (%)',
            value: 'humidity_cal_factor_percent',
            formatter: this.parseNumber,
            align: 'left',
            sortable: true
        },
        {
            text: 'Tipo Calibración',
            value: 'calibration_type',
            formatter: this.parseCalibrationType,
            align: 'left',
            sortable: true
        }
    ];
    modalTitle: string = 'Aplicar factor manual';
    dateRangeSelected: any = [];
    errorMsg: string = '';
    calibrationFactor: string = '';
    humidityFactor: string = '';
    startDate: any = null;
    startHour: string = '';
    endDate: any = null;
    endHour: string = '';

    parseNumber(value) {
        return parseFloatNumber(value, 6);
    }

    parseCalibrationType(calibrationType) {
        let calibrationTypeIndex = this.$_getInsuranceProperties['calibration_type_easy_desc'].findIndex(
            item => Number(item['id']) == calibrationType
        );

        if (calibrationTypeIndex !== -1) {
            return this.$_getInsuranceProperties['calibration_type_easy_desc'][calibrationTypeIndex]['value'];
        }
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    get isPatch() {
        if (this.patchData !== null) {
            return true;
        } else {
            return false;
        }
    }

    updateCalibrationFactor(value) {
        this.calibrationFactor = value;
    }
    updateHumidityFactor(value) {
        this.humidityFactor = value;
    }

    changeDateRange(value) {
        this.dateRangeSelected = value;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    showLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    showSuccessLoadingDialog(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg
        });
        this.closeModal();
    }
    showCatchLoadingDialog(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    updateStartDate(value) {
        this.startDate = value;
    }
    updateStartHour(value) {
        this.startHour = value;
    }
    updateEndDate(value) {
        this.endDate = value;
    }
    updateEndHour(value) {
        this.endHour = value;
    }

    submit() {
        let data = this.getData;
        if (!this.isPatch) {
            if (!this.saveOnMemory) {
                this.postFactor(data);
            } else {
                this.addNewManualFactor(data);
                this.closeModal();
            }
        } else {
            if (!this.saveOnMemory) {
                this.patchFactor(data);
            } else {
                this.updateManualFactor(data);
                this.closeModal();
            }
        }
    }

    postFactor(data) {
        this.showLoadingDialog('Guardando...');
        this.$emit('loading-table', true);
        InsuranceServices.postCustomCalibrationFactor(data)
            .then(res => {
                let msg = res['message'] !== undefined ? res['message'] : 'Se ha creado el periodo con error';
                this.$emit('loading-table', false);
                this.showSuccessLoadingDialog(res, msg);
                this.addNewManualFactor(res['custom_calibration_factor']);
            })
            .catch(err => {
                this.$emit('loading-table', false);
                this.showCatchLoadingDialog(err, 'Ocurrio un error');
            });
    }

    patchFactor(data) {
        let idToPatch = this.patchData !== null ? this.patchData['id'] : null;

        if (idToPatch) {
            this.$emit('loading-table');
            this.showLoadingDialog('Modificando...');
            InsuranceServices.patchCustomCalibrationFactor(idToPatch, data)
                .then(res => {
                    this.$emit('loading-table', false);
                    this.updateManualFactor(res['data']['custom_calibration_factor']);
                    this.$_successLoadingDialog({
                        response: res.data,
                    });
                    this.closeModal();
                })
                .catch(err => {
                    this.$emit('loading-table', false);
                    this.showCatchLoadingDialog(err, 'No se pudo modificar el factor manual');
                });
        }
    }

    loadPatchData() {
        if (this.isPatch && this.patchData !== null) {
            this.modalTitle = 'Modificar factor manual';
            // console.log("this.patchData['start_date']", this.patchData['start_date']);
            // console.log("this.patchData['end_date']", this.patchData['end_date']);
            // 2022-05-04T18:05:00
            let startDate = moment(this.patchData['start_date'], 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let startHour = moment(this.patchData['start_date'], 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
            let endDate = moment(this.patchData['end_date'], 'YYYY-MM-DDTHH:mm:ss').format('YYYY-MM-DD');
            let endHour = moment(this.patchData['end_date'], 'YYYY-MM-DDTHH:mm:ss').format('HH:mm');
            // console.log(startHour);
            // console.log(endHour);
            this.updateStartDate(startDate);
            this.updateEndDate(endDate);
            this.updateStartHour(startHour);
            this.updateEndHour(endHour);
            this.updateCalibrationFactor(this.patchData['calibration_factor']);
            this.updateHumidityFactor(this.patchData['humidity_calibration_factor']);
        } else {
            this.updateStartHour('00:00');
            this.updateEndHour('23:59');
            this.updateHumidityFactor(0);
            this.updateCalibrationFactor(0);
        }
    }

    get getData() {
        return {
            vehicle: this.vehicleID,
            id: this.isPatch && this.patchData !== null ? this.patchData['id'] : getUniqueId(),
            start_date: this.getFullTimestamp(this.startDate, this.startHour),
            end_date: this.getFullTimestamp(this.endDate, this.endHour),
            calibration_factor: this.calibrationFactor === '' ? 0 : Number(this.calibrationFactor),
            humidity_calibration_factor: this.humidityFactor === '' ? 0 : Number(this.humidityFactor)
        };
    }

    getFullTimestamp(date, hour) {
        return date + 'T' + hour;
    }

    get formIsValid() {
        this.setErrorForm('');
        if (this.startDate == null) {
            this.setErrorForm('No seleccionó Fecha de Inicio');
            return false;
        }

        if (this.endDate == null) {
            this.setErrorForm('No seleccionó Fecha de Fin');
            return false;
        }

        return true;
    }

    @Emit()
    closeModal() {}

    @Emit()
    addNewManualFactor(item) {
        return item;
    }

    @Emit()
    updateManualFactor(item) {
        return item;
    }

    mounted() {
        this.loadPatchData();
    }
}
